import { combineReducers } from "redux";
import { bolEmailReducer } from './bolEmail';
import { pushNotificationReducer } from './pushNotificationPopup';
import { bolReducer } from './list';


const reducer = combineReducers({
    list: bolReducer,
    pushNotificationPopup: pushNotificationReducer,
    bolEmail: bolEmailReducer,
})

export default reducer;